import React from 'react';
import Typography from '../../../../components/common/Typography';
import { IconButton } from '../../../../components/common/Button';

const ItemTitleSection = ({ title, handleDeleteButton, disabled }) => {
  return (
    <div className="displayFlex" style={{ gap: '10px' }}>
      <Typography variant="body1Bold">{title}</Typography>
      <div className="titleLine"></div>
      {!disabled && (
        <IconButton
          deleteIcon
          variant="outline"
          size="small"
          color="gray"
          alt={`${title} 삭제`}
          onClick={handleDeleteButton}
        />
      )}
    </div>
  );
};

export default ItemTitleSection;
